import { useMemo } from 'react'
import { useMailboxBounceAnalytics, MailboxBounceData } from './useMailboxBounceAnalytics'

export interface ClientMailboxBounceFilter {
  clientName: string
  timePeriod: 'today' | 'yesterday' | 'last_7_days' | 'last_14_days' | 'last_30_days'
}

export function useClientMailboxBounceAnalytics(filter?: ClientMailboxBounceFilter) {
  const { data: allBounceData = [], isLoading, refetch } = useMailboxBounceAnalytics()

  const filteredData = useMemo(() => {
    if (!filter) return allBounceData

    return allBounceData.filter(mailbox => {
      // Filter by client name
      const matchesClient = mailbox.client_name === filter.clientName
      
      // Filter by time period - only show mailboxes that have bounces in the selected period
      let hasBounceInPeriod = false
      switch (filter.timePeriod) {
        case 'today':
          hasBounceInPeriod = mailbox.bounces_today > 0
          break
        case 'yesterday':
          // For yesterday, we need bounces in the last 2 days but not today
          hasBounceInPeriod = mailbox.bounces_7d > mailbox.bounces_today && mailbox.bounces_today === 0
          break
        case 'last_7_days':
          hasBounceInPeriod = mailbox.bounces_7d > 0
          break
        case 'last_14_days':
          hasBounceInPeriod = mailbox.bounces_14d > 0
          break
        case 'last_30_days':
          hasBounceInPeriod = mailbox.total_bounces > 0
          break
      }

      return matchesClient && hasBounceInPeriod
    })
  }, [allBounceData, filter])

  return {
    data: filteredData,
    isLoading,
    refetch
  }
}